<template lang="pug">
#about-event
  .address-block.about-block
    //- google-map(
    //-   :location="event._embedded.location"
    //-   :name="event._embedded.location.id"
    //- )
    cl-img(
      v-if="event._embedded.artwork"
      :cl-id="event._embedded.artwork.cl_id"
      :transform="{ width: '1000', height: '563' }"
    )
    .content(v-if="event._embedded.location.id")
      .address.block-content
        b-icon.has-text-grey-lighter(icon="map-marker" size="is-small" pack="fas")
        div
          p.has-text-weight-semibold {{ event._embedded.location.label }}
          div(v-html="event._embedded.location.address.string")
  .details-block.content
    .cost-block.about-block(v-if="fromCost > 0")
      .block-content
        b-icon.has-text-grey-lighter(icon="money-bill" size="is-small" pack="fas")
        span From {{ fromCost | cents }} per person
    .date-block.about-block(v-if="!isProject")
      .block-content
        b-icon.has-text-grey-lighter(icon="calendar" size="is-small" pack="fas")
        event-date(
          format="dddd MMMM Do"
          :filter="false"
          :value="event"
        )
    .time-block.about-block(v-if="!isProject && event.dates.length !== 2 && event.start_time")
      .block-content
        b-icon.has-text-grey-lighter(icon="clock" size="is-small" pack="fas")
        div
          span(v-if="event.end_time") {{ event.start_time | date('h:mm A') }} &ndash; {{ event.end_time | date('h:mm A') }}
          span(v-else) Starts at {{ event.start_time | date('h:mm A') }}
    .contact-block.about-block(v-if="event._embedded.contact.id")
      .block-content
        b-icon.has-text-grey-lighter(icon="comments-alt" size="is-small" pack="fas")
        span For questions, please contact:
      .media
        .media-left
          cl-img.avatar(
            v-if="event._embedded.contact.profile_image"
            :cl-id="event._embedded.contact.profile_image.cl_id"
            :transform="{ width: 132, height: 132, crop: 'thumb' }"
          )
        .media-content
          p.has-text-weight-semibold {{ event._embedded.contact.name }}
          .contact-info
            small(v-if="event._embedded.contact.email")
              a(:href="`mailto:${event._embedded.contact.email}?subject=Question about ${event.title}`")
                span {{ event._embedded.contact.email }}
            small(v-if="event._embedded.contact.phone_number")
              a(:href="`tel:${event._embedded.contact.phone_number}`")
                span {{ event._embedded.contact.phone_number }}
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import EventDate from '@/components/events/EventDate.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'about-event',
  components: {
    EventDate,
    GoogleMap,
  },
  computed: {
    ...mapGetters({
      event: getterTypes.GET_EVENT,
    }),
    fromCost() {
      if (!this.event.payment_required || this.event._embedded.packages.length === 0) return 0;
      const cheapest = _.minBy(this.event._embedded.packages, p => p.cost);
      if (cheapest) return cheapest.cost;
      return 0;
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    isProject() {
      return this.event.type === 'project';
    },
  },
};
</script>

<style lang="scss">
#about-event {
  @include sidebar;
  box-shadow: 0 0 30px rgba(0,0,0,0.05);
  .about-block {
    &.address-block {
      .content {
        padding-bottom: 0.35rem;
      }
      .block-content {
        align-items: flex-start;
        .icon {
          position: relative;
          top: 6px;
        }
      }
    }
    .block-content {
      align-items: center;
      .icon {
        margin-right: 0.75rem;
      }
    }
  }
  .details-block {
    border-radius: 0 0 4px 4px;
  }
  .contact-block {
    .media {
      margin-top: 1.25rem;
      align-items: center;
      .avatar {
        width: 66px;
        height: 66px;
        border-radius: 100px;
      }
      p {
        margin-bottom: 0.15rem;
      }
      .contact-info {
        small {
          display: block;
          & + small {
            margin-top: 0.15rem;
          }
          a {
            color: $grey-light;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" theme="cwo">
#about-event {
  .address-block {
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
